/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import * as CONSTANTS from 'Utils/constants';
import makeApi, { URLS } from 'Utils/apiUtil';
import Utils from 'Utils/utils';
import technologiesFilterPopupImg from 'Assets/png/technologiesFilterPopupImg.jpg';
import { ReactComponent as ArrowIcon } from 'Assets/svg/right-arrow.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import HocPopupComponent from 'Components/common/hocPopupComponent';
import Button from 'Components/common/Button';
import { userDetail } from 'Stores/userDetail';

class PaidUserTechnologyFilterPopupState {
  @observable showPopup = false;

  @action
  setShowPopup = (val = false) => {
    this.showPopup = val;
  };
}
const paidUserTechnologyFilterPopupState = new PaidUserTechnologyFilterPopupState();

const TechnologyPaidUserPopup = observer(props => {
  const { isFreeTrial } = userDetail;
  const { closeClick = () => {} } = props;
  const scheduleDemoBtnClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_AS_EVENTS.LB_AS_TECHNOLOGY_SEARCH_SCHEDULE_DEMO,
      {},
    );
    closeClick();

    Utils.handleTalkToSalesForTeckFilter();
    if (Utils.isPaidUser()) {
      const config = {
        url: URLS.technographicDemoRequest,
      };
      makeApi(config)
        .then(response => {})
        .catch(error => {
          console.log('URLS.technographicDemoRequest error ', error);
        });
    }
  };

  const notInterestedClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_AS_EVENTS.LB_AS_TECHNOLOGY_FILTER_POPUP_CLICK_NOT_INTERESTED,
      {},
    );
    closeClick();
  };

  return (
    <div className="technology-demo-popup-wrapper">
      <span className="close-popup" onClick={e => closeClick()}>
        <CloseIcon />
      </span>
      <img src={technologiesFilterPopupImg} alt="technologiesFilterPopupImg" />
      <div className="msg-text-wrap">
        Attack based on tech-stack! Talk to us today to enable techno-graphic
        search filters.
      </div>
      <Button
        btnText="Get Quote"
        icon={false}
        iconName=""
        type="button"
        className="action-btn"
        svg={<ArrowIcon className="arrow-right" width={14} height={18} />}
        click={e => scheduleDemoBtnClick(e)}
      />
      <div className="not-interested-btn" onClick={e => notInterestedClick()}>
        Not interested
      </div>
    </div>
  );
});

const PaidUserTechnologyFilterPopup = observer(props => {
  const closeTechDemoPopup = () => {
    paidUserTechnologyFilterPopupState.setShowPopup(false);
  };
  return paidUserTechnologyFilterPopupState.showPopup ? (
    <HocPopupComponent
      customClassName="technographic-schedule-demo-popup"
      closeClick={closeTechDemoPopup}
    >
      <TechnologyPaidUserPopup closeClick={closeTechDemoPopup} />
    </HocPopupComponent>
  ) : (
    ''
  );
});

export { PaidUserTechnologyFilterPopup, paidUserTechnologyFilterPopupState };
export default PaidUserTechnologyFilterPopup;
